import { render, staticRenderFns } from "./CogsMenu.vue?vue&type=template&id=d1a7beae&"
import script from "./CogsMenu.vue?vue&type=script&lang=js&"
export * from "./CogsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports